import styled from 'styled-components';

const StyledNameTag = styled.div`
  border: 1px solid ${({ theme }) => theme.color.borderColor};
  border-radius: ${(props) => props.theme.radius.md};
  display: flex;
  flex-direction: row;
  gap: 1rem;
  width: fit-content;
  padding: 0.5rem 0.75rem;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => theme.color.white};
`;

const StyledProfileImage = styled.img`
  height: 70px;
  aspect-ratio: 1/1;
  object-fit: cover;
  border-radius: 100%;
`;

const StyledInfo = styled.div`
  display: block;
`;

export { StyledNameTag, StyledProfileImage, StyledInfo };
